import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi, JsonResponse } from '../../services/api';
import LoadingPanel from '../LoadingPanel';

type Props = RouteComponentProps<{
    childId: string;
    childScheduleId: string;
}>

type State = {
    isLoading: boolean;
    activities: Activity[];
}
type Activity = {
    ActivityItemId : number;
    Title: string;
    Description: string;
    Type: number;
    StartTime: string;
    EndTime: string;
    ImgData: string;
}


export default class ScheduleActivities extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            activities:[],
        }
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page

        let childId = parseInt(this.props.match.params.childId) || 0;
        let childScheduleId = parseInt(this.props.match.params.childScheduleId) || 0;

        this.fetchData(childId, childScheduleId);
    }

    public render()
    {
        if (!this.state.isLoading && this.state.activities.length === 0) {
            return <h1 className="text-center p-5" >No activities are recorded for today.</h1>
        }

        return <React.Fragment>
            <br />

            {this.state.isLoading && <LoadingPanel /> }
            <div className="row">
                <div className="col">
                    <h3><b>Behavior</b></h3>
                    {this.state.activities.filter(x=>x.Type == 4).map((activity) => {
                        return <div>
                            <p>{activity.Title}<br />{activity.Description}</p>
                        </div>
                    })}
                    <h3><b>Naps</b></h3>
                    {this.state.activities.filter(x=>x.Type == 1).map((activity) => {
                        return <div>
                            <p>{activity.StartTime} - {activity.EndTime}</p>
                        </div>
                    })}

                    <h3><b>Meals</b></h3>
                    {this.state.activities.filter(x=>x.Type == 2).map((activity) => {
                        return <div>
                            <p>{activity.Title}<br />{activity.Description}</p>
                        </div>
                    })}
                </div>
                <div className ="col">
                    <h3><b>Bathroom Incidents</b></h3>
                    {this.state.activities.filter(x=>x.Type == 3).map((activity) => {
                        return <div>
                            <p>{activity.Title}<br />{this.getBathroomDescription(activity.Description)}</p>
                        </div>
                    })}
                    <h3><b>Activity</b></h3>
                    {this.state.activities.filter(x=>x.Type == 5).map((activity) => {
                        return <div>
                            <p><i>{activity.Title}</i><br />{activity.Description}</p>
                        </div>
                    })}
                    <h3><b>Pictures</b></h3>
                    {this.state.activities.filter(x => x.Type == 6).map((picture, i) => {
                        return <div>
                                <p><a href="#" data-toggle="modal" data-target={`.bd-example-modal-lg-${i}`}><i>{picture.Title}</i></a><br />{picture.Description}</p>
                                <div className={`modal fade bd-example-modal-lg-${i}`} tabIndex={-1} role="dialog" id="myModal">
                                    <div className="modal-dialog modal-lg" role="document">
                                        <div className="modal-content k-form">
                                            <div className="modal-header">
                                                <h5 className="modal-title text-center w-100">{picture.Title}</h5>
                                            </div>
                                            <div className="modal-body">
                                                <div className="camera-picture text-center">
                                                    <img className="img-fluid" src={`data:image/jped;base64,${picture.ImgData}`} width={400} height={500} alt={picture.Description} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    })}
                </div>
            </div>
        </React.Fragment>
    }
    private getBathroomDescription(description: string) {
        switch(description)
        {
            case "1":
                return "Diaper";
            case "2":
                return "Underwear Wet";
            case "3":
                return "Sat on Potty";
            default:
                return  "Not Recorded"
        }
    }

    private fetchData(childId: number , childScheduleId: number)
    {
        this.setState({ isLoading: true });
        fetchApi(`api/ChildSchedule/Activities/${childScheduleId}`)
            .then((activities: Activity[]) => {
                this.setState({ activities, isLoading: false });
            });
    }
}
